import {TicketViewEnum} from "../../../ticket-view.enum";

export class TmCreateTicketAction {
    mode: TicketViewEnum;
    forceRefresh: boolean
}